import * as React from 'react';
import { clsx } from 'clsx';

type Props = Readonly<{
	name: string
	className?: string,
	headerClassName?: string,
	innerClassName?: string,
	children?: React.ReactNode
}>;

function Layout({
	name,
	children,
	className = '',
	headerClassName = '',
	innerClassName = ''
}: Props) {

	return (<>
		<section className={clsx(className, "max-w-screen-xl mx-auto text-center px-4 sm:px-8")}>
			<h1 className={clsx(headerClassName, "text-primary-500 mt-8 sm:mt-14 mb-8 text-4xl sm:text-5xl lg:text-6xl")}>{name}</h1>
		</section>

		<section className="mx-auto relative max-w-screen-xl">
			<div className={clsx(innerClassName, "flex flex-wrap px-3 sm:px-4")}>
				{children}
			</div>
		</section>
	</>);
}

export default Layout;
